import { ChangeDetectorRef, inject, DestroyRef, Directive, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { DashboardsService } from "@shared/dashboards-service/dashboards.service";
import { IDashboardModel } from "@app/views-interfaces/dashboard-model.interface";
import { CardModalService } from "@shared/card-modal";
import { ApplicationType, isJobsBilling, isiFirmTax } from "@app/views-interfaces/ApplicationType.enum";

@Directive()
export abstract class PanelIcon implements OnInit {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly dashboardsService = inject(DashboardsService);
    protected readonly changeDetectorRef = inject(ChangeDetectorRef);
    protected readonly cardModalService = inject(CardModalService);

    protected currentDashboard: IDashboardModel | undefined;
    protected isUsersPanelIconsVisible = false;
    protected isContactClickable = false;
    protected currentDashboardChangedSubscription: Subscription;

    constructor() {
        this.currentDashboardChangedSubscription = this.dashboardsService.currentDashboardChanged$.subscribe(() => {
            this.init();
        });

        this.destroyRef.onDestroy(() => {
            this.currentDashboardChangedSubscription.unsubscribe();
        });
    }

    public ngOnInit(): void {
        this.init();
    }

    protected async init() {
        this.currentDashboard = await this.dashboardsService.getCurrentDashboard();
        this.isUsersPanelIconsVisible = this.currentDashboard?.ApplicationType === ApplicationType.TaxprepT1;
        this.isContactClickable = !!(
            this.currentDashboard &&
            (isJobsBilling(this.currentDashboard.ApplicationType) || isiFirmTax(this.currentDashboard.ApplicationType))
        );
        this.changeDetectorRef.detectChanges();
    }
}
